import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { LinkContainer } from 'react-router-bootstrap';
import { actionCreators } from '../../store/modules/User';
import List from '../../containers/List';

const UserList = (props) => {
  const {
    users, paging, requestList, preferTable, switchDisplayStyle, filters,
  } = props;

  const columns = [
    {
      id: 'id',
      Header: 'Id',
      accessor: 'id',
      sortable: false,
    },
    {
      id: 'phone',
      Header: 'Tālrunis',
      accessor: 'phone',
      sortable: false,
    },
    {
      id: 'email',
      Header: 'Epasts',
      accessor: 'email',
      sortable: false,
    },
    {
      accessor: 'id',
      Cell: cell => (
        <LinkContainer to={`/user/${cell.value}/profile`} exact>
          <div className="gaas-tile-btn">Profils</div>
        </LinkContainer>
      ),
      maxWidth: 120,
      sortable: false,
    },
    {
      accessor: 'id',
      Cell: cell => (
        <LinkContainer to={`/user/${cell.value}/coupon`} exact>
          <div className="gaas-tile-btn">Kuponi</div>
        </LinkContainer>
      ),
      maxWidth: 120,
      sortable: false,
    },
  ];
  return (
    <List title="Lietotāji"
      requestList={requestList}
      filters={filters}
      {...paging}
      tableData={users}
      tableColumns={columns}
      preferTable={preferTable}
      switchDisplayStyle={switchDisplayStyle}>
      {users.map(user => (
        <div key={user.id}>
          <div className="gaas-tile">
            <div className="gaas-tile-heading">
              <span className="text-ellipsis">
                {user.id}
              </span>
            </div>
            <div className="gaas-tile-body">
              <div className="m-b-md padder">
                <div className="row">
                  <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                    <i className="glyphicon glyphicon-screenshot m-r-sm" />
                    <span className="text-underline">Tālrunis</span>
                    {' : '}
                    <span>{user.phone}</span>
                    <br />
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                    <i className="glyphicon glyphicon-screenshot m-r-sm" />
                    <span className="text-underline">Epasts</span>
                    {' : '}
                    <span>{user.email}</span>
                    <br />
                  </div>
                </div>
              </div>
            </div>
            <div className="gaas-tile-footer m-t-sm" style={{ borderBottomLeftRadius: '50%', borderBottomRightRadius: '50%' }}>
              <LinkContainer to={`/user/${user.id}/profile`} exact
                style={{ float: 'left', width: '50%' }}>
                <div className="gaas-tile-btn">Profils</div>
              </LinkContainer>
              <LinkContainer to={`/user/${user.id}/coupon`} exact
                style={{ float: 'left', width: '50%' }}>
                <div className="gaas-tile-btn">Kuponi</div>
              </LinkContainer>
            </div>
            <div className="clear" />
          </div>
        </div>
      ))}
    </List>
  );
};

UserList.propTypes = {
  users: PropTypes.arrayOf(PropTypes.shape({ id: PropTypes.string, name: PropTypes.string })).isRequired,
  requestList: PropTypes.func.isRequired,
  paging: PropTypes.shape({ totalPages: PropTypes.number }).isRequired,
  preferTable: PropTypes.bool.isRequired,
  switchDisplayStyle: PropTypes.func.isRequired,
  filters: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

export default connect(
  state => ({
    users: state.user.list,
    paging: state.user.paging,
    preferTable: state.user.preferTable,
    filters: state.user.filters,
  }),
  dispatch => bindActionCreators(actionCreators, dispatch),
)(UserList);



// WEBPACK FOOTER //
// ./src/components/user/List.jsx